import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';

function productBatchStocksStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_BATCH_STOCKS_STARTED,
  });
}

function productBatchStocksSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_BATCH_STOCKS_SUCCESS,
  });
}

function productBatchStocksFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_BATCH_STOCKS_FAILED,
  });
}

export {
  productBatchStocksStarted,
  productBatchStocksSuccess,
  productBatchStocksFailed,
};
